import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { ThemeProvider, LanguageProvider, CurrencyProvider, ZoomProvider, AuthDialogProvider, CompareProvider } from "./contexts";
import { AuthProvider } from "./contexts/AuthContext";
import "@/App.css";

// Layout
import Layout from "./components/Layout";

// Pages
import HomePage from "./pages/HomePage";
import ListingsPage from "./pages/ListingsPage";
import CarDetailPage from "./pages/CarDetailPage";
import CityPage from "./pages/CityPage";
import CategoryPage from "./pages/CategoryPage";
import BrandPage from "./pages/BrandPage";
import SupplierPage from "./pages/SupplierPage";
import ContactPage from "./pages/ContactPage";
import AboutPage from "./pages/AboutPage";
import FAQPage from "./pages/FAQPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import SupportPage from "./pages/SupportPage";
import PricingPage from "./pages/PricingPage";
import PartnersPage from "./pages/PartnersPage";
import OffersPage from "./pages/OffersPage";
import ProfilePage from "./pages/ProfilePage";
// BookingPage is hidden for the current release. Keep import here for later restore.
// import BookingPage from "./pages/BookingPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import ComparePage from "./pages/ComparePage";

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <LanguageProvider>
          <CurrencyProvider>
            <ZoomProvider>
              <AuthProvider>
                <CompareProvider>
                  <div className="App min-h-screen bg-[var(--bg-primary)] transition-colors duration-300">
                    <BrowserRouter>
                      <AuthDialogProvider>
                        <Routes>
                          <Route element={<Layout />}>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/cars" element={<ListingsPage />} />
                            <Route path="/offers" element={<OffersPage />} />
                            <Route path="/cars/:id" element={<CarDetailPage />} />
                            <Route path="/compare" element={<ComparePage />} />
                            <Route path="/pricing" element={<PricingPage />} />
                            <Route path="/partners" element={<PartnersPage />} />
                            <Route path="/city/:slug" element={<CityPage />} />
                            <Route path="/category/:slug" element={<CategoryPage />} />
                            <Route path="/brand/:slug" element={<BrandPage />} />
                            <Route path="/supplier/:id" element={<SupplierPage />} />
                            <Route path="/contact" element={<ContactPage />} />
                            <Route path="/about" element={<AboutPage />} />
                            <Route path="/faq" element={<FAQPage />} />
                            <Route path="/privacy" element={<PrivacyPolicyPage />} />
                            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                            <Route path="/support" element={<SupportPage />} />
                            <Route path="/profile" element={<ProfilePage />} />
                            {/* Booking flow is hidden for the current release. Keep route here for later restore. */}
                            {/* <Route path="/booking/:carId" element={<BookingPage />} /> */}
                            <Route path="/reset-password" element={<ResetPasswordPage />} />
                          </Route>
                        </Routes>
                      </AuthDialogProvider>
                    </BrowserRouter>
                    <Toaster position="top-right" />
                  </div>
                </CompareProvider>
              </AuthProvider>
            </ZoomProvider>
          </CurrencyProvider>
        </LanguageProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
